import axios from "axios";
import API_ENDPOINT from "../config";
import { checkIfNotEmpty } from "../utils/utils";

export const getUsersTable = async (token, fname, lname, username, email, pageNo = 0, entryLimit = 10) => {
  let fd = new FormData();
  fd.append("token", JSON.stringify(token));
  fd.append("identity", "wmhandler");
  fd.append("screen_name", "USERS");
  fd.append("fname", fname);
  fd.append("lname", lname);
  fd.append("username", username);
  fd.append("email", email);
  fd.append("pageNo", pageNo);
  fd.append("entryLimit", entryLimit);
  var res = await axios({
    method: "POST",
    url: `${API_ENDPOINT.apiUrl}adminPanel/getData`,
    data: fd,
  });
  return res.data;
};
export const getInstituteTable = async (
  token,
  instituteName,
  username,
  email
) => {
  let fd = new FormData();
  fd.append("token", JSON.stringify(token));
  fd.append("identity", "wmhandler");
  fd.append("screen_name", "INSTITUTE");
  fd.append("instituteName", instituteName);
  fd.append("username", username);
  fd.append("email", email);
  // fd.append("page_no",pageNo);
  var res = await axios({
    method: "POST",
    url: `${API_ENDPOINT.apiUrl}adminPanel/getData`,
    data: fd,
  });
  return res.data;
};

export const getPostsTable = async (
  token,
  postID,
  username,
  title,
  pageNo,
  typeOfPost
) => {
  let fd = new FormData();
  fd.append("token", JSON.stringify(token));
  fd.append("identity", "wmhandler");
  fd.append("screen_name", "POSTS");
  if (checkIfNotEmpty(postID)) {
    fd.append("post_Id", postID);
  }
  if(checkIfNotEmpty(username)) {
    fd.append("username", username);
  }
  fd.append("pageNo", pageNo);
  if (checkIfNotEmpty(typeOfPost)) {
    fd.append("type_of_post", typeOfPost);
  }
  if(checkIfNotEmpty(title)) {
    fd.append("title", title);
  }
  var res = await axios({
    method: "POST",
    url: `${API_ENDPOINT.apiUrl}adminPanel/getData`,
    data: fd,
  });
  return res.data;
};

export const getPointsTable = async (token, fname, lname, username, email) => {
  let fd = new FormData();
  fd.append("token", JSON.stringify(token));
  fd.append("identity", "wmhandler");
  fd.append("screen_name", "POINTS");
  fd.append("fname", fname);
  fd.append("lname", lname);
  fd.append("username", username);
  fd.append("email", email);
  // fd.append("page_no",pageNo);
  var res = await axios({
    method: "POST",
    url: `${API_ENDPOINT.apiUrl}adminPanel/getData`,
    data: fd,
  });
  return res.data;
};


export const handleApprovalRequest = async (token, userId, action) => {
  let fd = new FormData();
  fd.append("token", JSON.stringify(token));
  fd.append("user_id", userId);
  fd.append("action", action);
  var res = await axios({
    method: "POST",
    url: `${API_ENDPOINT.apiUrl}AdminPanel/handleApprovalRequest`,
    data: fd,
  });
  return res.data;
};
